import{css as _css}from"styled-components";/**
 * Hide and show content accessibly. The content is visually hidden, but
 * screen readers and other assistive technology still read it.
 * See http://snook.ca/archives/html_and_css/hiding-content-for-accessibility
 */const screenreaderOnly=_css(["position:absolute;top:0;left:0;overflow:hidden;clip:rect(1px,1px,1px,1px);width:1px;min-width:0;height:1px;min-height:0;padding:0;"]);export default screenreaderOnly;